import {Component, EventEmitter, inject, Input, OnDestroy, Output, SimpleChanges} from "@angular/core";
import {
  BaseComponent,
  WmsMessageComponent,
  WmsWizardComponent,
} from "@wms/app/components";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { TestComponent } from "./test/test.component";
import { ConfigComponent } from "./config/config.component";
import { runtimeEventManager, triggerFn } from "@wm/core";
import { find, findIndex, forEach, get, includes, isArray, isEmpty, keys, remove, set, some, startsWith } from "lodash-es";
import {
  getClonedObject,
  getValidJSON,
  isValidWebSocketURL,
} from "projects/core/src/utils/utils";
import {  ApisService, NotificationService, ServiceFactoryService, WebserviceService } from "@wms/app/services";
import { DB_CONSTANTS, replace, stringStartsWith, WS_CONSTANTS } from "@wms/app/core";
import { SWAGGER_CONSTANTS, VARIABLE_CONSTANTS } from "@wms/app/variables";
import X2JS from "x2js";
import {WebscoketService} from "@wms/app/webscoket.service";
@Component({
  selector: "wms-websocket",
  templateUrl: "./websocket.component.html",
  styleUrls: ["./websocket.component.less"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    WmsWizardComponent,
    TestComponent,
    ConfigComponent,
    WmsMessageComponent,
  ],
})
export class WebsocketComponent extends BaseComponent implements OnDestroy{
  @Input() wizardSteps?: any;
  @Input() viewMode: string;
  @Input() serviceDetails? : any

  testDisabled:boolean = false;
  MAX_MSG_COUNT = 20;
  webService: any;
  CONTENT_TYPE_KEY = VARIABLE_CONSTANTS.REST_SERVICE.CONTENT_TYPE_KEY;
  cachedParams: any;
  TYPE_KEY :string       = 'type';
  SCHEMA_KEY:any       = 'schema';
  ITEMS_KEY :string         = 'items';
  VARIABLE_APP_ENV   = SWAGGER_CONSTANTS.VARIABLE_APP_ENV;
  ALREADY_EXISTS  = '$already_exists$';
  serviceId: string;
  enableSave: boolean = false;
  webSocketService:WebscoketService;


  constructor(private notificationService: NotificationService,
    private serviceFactory: ServiceFactoryService,
    public apiService: ApisService
  ) {
    super();
    this.webService = inject(WebserviceService);
    this.webSocketService = inject(WebscoketService);
    this.webSocketService.disableDialogActions = false;
    this.webSocketService.webServiceMessage = null;
    this.webSocketService.buildRequestBody = null;


  }

  ngOnInit() {
    this.webSocketService.viewMode = this.viewMode
    this.webSocketService.resetWS();
    if(this.viewMode === 'edit' && this.serviceDetails?.name) {
      this.initialteWS()
    }
  }

  ngOnChanges(changes: any) {
    this.webSocketService.viewMode = this.viewMode
    if(this.viewMode === 'edit' && changes['serviceDetails']?.currentValue?.servicename === "WebSocketService"){
      this.webSocketService._socket?.close()
      this.initialteWS();
    }
  }

  initialteWS(){
      this.webSocketService.resetWS()
      this.webSocketService.ws['serviceType'] = {
        REST: 'REST',
        SOAP: 'SOAP',
        WEBSOCKET: 'WEBSOCKET',
        OPENAPI: 'OPENAPI'
      }
      this.webSocketService.ws['inputParams'] = []
      let serviceId = this.serviceDetails?.name
      this.getServiceDetails(serviceId)

  }

  getServiceDetails(serviceId:any){
      // set flag to disable the service name field
      this.webSocketService.ws.editMode          = true;
      this.webSocketService.ws.activeServiceType = VARIABLE_CONSTANTS.SERVICE_TYPE_WEBSOCKET;
      this.resetMessages();
      this.webService.getWebSocketServiceDetails({'projectID': this.projectService.getProjectId(), 'serviceID': serviceId}).then((response:any) => {
          let webSocketRequestInfo = response.webSocketRequestInfo,
              paths           = response.swagger.paths,
              pathObject      = paths[keys(paths)[0]],
              operationObject = pathObject[keys(pathObject)[0]];
          this.webSocketService.ws.restInfoQuery = {};
          this.webSocketService.ws.webSocketUrl = this.webSocketService.getParameterizedUrl(response.swagger);
          this.webSocketService.ws.inputParams = operationObject.parameters;
          this.webSocketService.setBuildRequestBody(response);
          this.setServiceId(response.serviceId || serviceId);
          this.setSampleRequestBody(webSocketRequestInfo.sampleRequestBody);
          this.setSampleResponseBody(get(webSocketRequestInfo, 'sampleWebSocketResponse.responseBody'));
          this.setParamSampleValues(webSocketRequestInfo.queryParams);
          this.webSocketService.processServiceSettings(response, this.webSocketService.ws.editMode, true);
          this.webSocketService.setParameterizedUrl(this.webSocketService.ws.inputParams, 'websocket');
          this.serviceId = response.serviceId || serviceId
      });
      // this.webServicePropertyChanged = false;
  }

  resetMessages() {
    this.webSocketService.ws.messages = [];
  }

  setServiceId(serviceId:any) {
    this.webSocketService.ws.serviceName = serviceId;
  }

  setSampleRequestBody(body:any) {
    this.webSocketService.ws.requestBody = body;
  }

  setSampleResponseBody(response:any) {
    this.webSocketService.ws.responseBody = response;
  }

  setParamSampleValues(values:any) {
    this.webSocketService.ws.sampleParamValues = values || {};
  }

  /**
   * connects to WebSocket service
   * on success, sends message if provided
   */
  test() {
    this.webSocketService.closeSocket();
    this.connect(() => {
      if (this.webSocketService.getRequestBody()) {
        this.sendMessage();
      }
      this.webSocketService.ws.isUrlChanged  = false;
      this.webSocketService.ws.isUrlTested   = true;
    });
  }

  // /**
  //  * if exists, closes an existing socket connection
  //  */
  // closeSocket() {
  //   if (this._socket) {
  //     this.resetMsgCount();
  //     this._socket.close();
  //     this.clearSocket();
  //   }
  // }
  //
  // /** * resets the message count variable*/
  // resetMsgCount() {
  //   this.msgCount = 0;
  // }
  //
  // /**
  //  * clears an existing socket connection variable
  //  */
  // clearSocket() {
  //   this._socket = null;
  // }

  /**
   * connect to a WebSocket service
   */
  connect(callback: any) {
    let url = this.webSocketService.getUrl();
    if (this.webSocketService.ws.editMode) {
      url = this.webSocketService.getUrlFromParameterizedUrl();
    }

    // validate URL
    if (!this.webSocketService.isValidURL(url)) {
      return;
    }

    this.webSocketService.toggleMessage(true, this.locale.MESSAGE_CONNECTING, "loading");
    // adding this timeout to resolve issue with closing previous socket connection. Need to debug this further.
    setTimeout(() => {
      this.getSocket(url, callback);
    }, 300);
  }

  // /**
  //  * Checks if the provided URL is a valid WebSocket URL
  //  * if not, throws respective error on the UI
  //  * @param url
  //  * @returns {boolean}
  //  */
  // isValidURL(url: any) {
  //   if (!url) {
  //     this.handleError(
  //       this.locale.MESSAGE_WEBSERVICE_IMPORT_FIELD_MISSING +
  //         this.locale.LABEL_WEB_SERVICE_REST_URL
  //     );
  //     return false;
  //   }
  //   if (!isValidWebSocketURL(url)) {
  //     this.handleError(this.locale.MESSAGE_INVALID_WS_URL);
  //     return false;
  //   }
  //   return true;
  // }
  //
  // /**
  //  * get the endpoint url entered
  //  * @returns {string}
  //  */
  // getUrl() {
  //   return this.webSocketService.ws.webSocketUrl;
  // }
  //
  // /**
  //  * get the endpoint url entered
  //  * @returns {string}
  //  */
  // getUrlFromParameterizedUrl() {
  //   let url = this.getParameterizedUrlFn();
  //   //Replace query and path params with their values
  //   url = this.getUrlWithParamValues(url);
  //   return url;
  // }
//
//   getParameterizedUrl(swagger:any) {
//     let paths           = swagger.paths,
//         pathObject      = paths[keys(paths)[0]];
//
//     return swagger.schemes[0] + '://' + swagger.host + swagger.basePath + pathObject[this.BASE_PATH_KEY] + pathObject[this.RELATIVE_PATH_KEY];
// }

  // /**
  //  * get the parameterizedUrl
  //  * @returns {string}
  //  */
  // getParameterizedUrlFn() {
  //   return this.webSocketService.ws.webSocketUrl;
  // }
  //
  // /**
  //  * get sample request body entered in UI
  //  * @returns {string|this.webSocketService.ws.requestBody|*}
  //  */
  // getRequestBody() {
  //   return this.webSocketService.ws.requestBody;
  // }
  //
  // /**
  //  * send message through the connected socket
  //  */
  // sendMessage() {
  //   let message = this.getRequestBody();
  //   this.getSocket().send(message);
  // }

  /**
   * connect to the given WebSocket URL.
   * If connection exists, return the corresponding socket variable
   * @param url
   * @returns {*}
   */
  getSocket(url?: any, callback?: any) {
    if (this.webSocketService._socket && !url) {
      return this.webSocketService._socket;
    }

    this.webSocketService._socket = new WebSocket(url);
    this.webSocketService._socket.onopen = () => {
      this.socketOpenHandler();
      triggerFn(callback);
    };
    this.webSocketService._socket.onerror = this.socketErrorHandler.bind(this);
    this.webSocketService._socket.onmessage = this.socketMessageHandler.bind(this);
    this.webSocketService._socket.onclose = this.socketCloseHandler.bind(this);
    return this.webSocketService._socket;
  }

  /**
   * handler for onOpen event of a socket connection
   */
  socketOpenHandler() {
    this.webSocketService.toggleMessage(
      true,
      this.locale.MESSAGE_CONNECTION_SUCCESSFUL,
      "success"
    );
    this.setConnectionStatus(true);
    this.webSocketService.setServiceTestedStatus(true);
  }

  /**
   * handler for onError event of a socket connection
   */
  socketErrorHandler() {
    this.webSocketService.toggleMessage(true, "Error while connecting", "error");
    this.setConnectionStatus(false);
  }

  /**
   * handler for onClose event of a socket connection
   */
  socketCloseHandler() {
    this.setConnectionStatus(false);
    this.webSocketService.clearSocket();
  }

  /**
   * handler for onMessage event of a socket connection
   * @param evt
   */
  socketMessageHandler(evt: { data: any }) {
    this.addMessage(evt.data);
    this.webSocketService.setServiceTestedStatus(true);
    this.incrementMsgCount();
    this.checkMsgLimit();
  }

  setConnectionStatus(status: boolean) {
    set(this, "ws.websocket.connectionStatus", status);
  }

  // setServiceTestedStatus(status: boolean) {
  //   this.webSocketService.ws.serviceTested = status;
  // }

  // //Replace query and path params with their values
  // getUrlWithParamValues(url: string) {
  //   // let pathParams = eval("ws.inputParams | filter: {in: ws.paramType.PATH}");
  //   const pathParams = this.webSocketService.ws.inputParams.filter((param: { in: any; }) => param.in === this.webSocketService.ws.paramType.PATH);
  //   if (this.ws.restInfoQuery) {
  //     forEach(this.ws.restInfoQuery, (value, key) => {
  //       url = url.replace("{" + key + "}", value);
  //     });
  //   }
  //   if (!isEmpty(pathParams)) {
  //     this.ws.restInfoPaths = this.ws.restInfoPaths || {};
  //     forEach(pathParams, (param) => {
  //       url = url.replace(
  //         "{" + param.name + "}",
  //         this.ws.restInfoPaths[param.name]
  //       );
  //     });
  //   }
  //   return url;
  // }

  /**
   * If messages received from WebSocket service reach the upper limit.
   * connection is closed and counter is reset.
   */
  checkMsgLimit() {
    if (this.getMsgCount() >= this.MAX_MSG_COUNT) {
      this.webSocketService.closeSocket();
    }
  }

  /**
   * gets the message count variable
   * @returns {number}
   */
  getMsgCount() {
    return this.webSocketService.msgCount;
  }

  /**
   * increments the message count variable
   */
  incrementMsgCount() {
    this.webSocketService.msgCount++;
  }

  /**
   * appends the response in messages models
   * @param msg
   */
  addMessage(msg: any) {
    this.webSocketService.ws.messages.push({ type: "response", message: msg });
  }

  // // function for toggling loading, failure  and validation messages
  // toggleMessage(show?: boolean, msg?: any, type?: string) {
  //   if (show) {
  //     this.webServiceMessage = { caption: msg || "", type: type };
  //     this.disableDialogActions = type === "loading";
  //   } else {
  //     this.disableDialogActions = false;
  //     this.webServiceMessage = null;
  //   }
  // }
  //
  // handleError(error: any, options?: { fallbackMsg?: any; type?: any }) {
  //   options = options || {};
  //
  //   let fallbackMsg = options.fallbackMsg || "MESSAGE_ERROR_OCCURRED",
  //     errorType = options.type || "inline";
  //
  //   error =
  //     typeof error === "string"
  //       ? error
  //       : this.locale[fallbackMsg] || fallbackMsg;
  //
  //   // based on error type, display the error-message
  //   if (errorType === "inline") {
  //     this.webSocketService.toggleMessage(true, error, "error");
  //   } else {
  //     this.notificationService.show(
  //       "error",
  //       this.locale.MESSAGE_ERROR_TITLE,
  //       error
  //     );
  //   }
  // }

  configureWebSocketService() {
    let params,
      responseBody = this.webSocketService.getSampleResponse(),
      jsonResponse = getValidJSON(responseBody)
        ? null
        : this.xmlToJson(responseBody) || null,
      url = this.webSocketService.ws.editMode
        ? this.webSocketService.getUrlFromParameterizedUrl()
        : this.webSocketService.getUrl();
    // validate URL
    if (!this.webSocketService.isValidURL(url)) {
      return;
    }
    params = {
      data: {
        endpointAddress: url,
        method: "GET",
        contentType: "",
        sampleRequestBody: this.webSocketService.getRequestBody(),
        headers: {},
        sampleWebSocketResponse: {
          contentType: "",
          statusCode: "",
          convertedResponse: jsonResponse,
          responseBody: responseBody,
        },
        authType: "NONE",
      },
      urlParams: {
        projectID: this.projectService.getProjectId(),
      },
    };
    this.webSocketService.toggleMessage(true, this.locale.LABEL_CONFIGURING_SOCKET_SERVICE,  "loading");
    this.webService.configureWebSocketService(params).then((response: any) => {
        this.webSocketService.setBuildRequestBody(response);
        this.webSocketService.processServiceSettings(response, this.webSocketService.ws.editMode, true);
        this.webSocketService.closeSocket();

        // increment the service setting step
        this.webSocketService.ws.stepCount += 1;
        this.webSocketService.toggleMessage(false);
        // Utils.triggerFn(success);
      })
      .catch((error: any) => {
        this.webSocketService.handleError(error, {fallbackMsg: "error while configuring socket service, please check server logs for more info." });
      });
  }

  // getSampleResponse() {
  //   return this.webSocketService.ws.responseBody;
  // }

  // setBuildRequestBody(body: any) {
  //   this.buildRequestBody = body;
  // }
  //
  // processServiceSettings(
  //   settings: any,
  //   skipExtractInfo: boolean,
  //   extendInputParams: any
  // ) {
  //   let pathObject =
  //       settings.swagger.paths[Object.keys(settings.swagger.paths)[0]],
  //     operationObject = pathObject[Object.keys(pathObject)[0]],
  //     existingInputParams = getClonedObject(this.ws.inputParams);
  //
  //   operationObject.parameters = operationObject.parameters || [];
  //   // if skipExtractInfo flag is set,
  //   // then info extraction sent from backend is not required
  //   if (!skipExtractInfo) {
  //     this.ws.restURL     = this.getParameterizedUrl(settings.swagger);
  //     this.ws.serviceName = settings.serviceId;
  //   }
  //   if (extendInputParams) {
  //     this.ws.inputParams = operationObject.parameters;
  //     //push the additional params not existing in swagger response.
  //     forEach(existingInputParams, (parameterObj) => {
  //       let inputObj = find(this.ws.inputParams, { name: parameterObj.name });
  //       let paramObj = find(existingInputParams, { name: parameterObj.name });
  //       // changing the type of param based on its format (since type is configured as 'string' for server side properties)
  //       if (inputObj) {
  //         inputObj.type = paramObj.format || inputObj.type;
  //         //update the items.type for the params only if content type is not multipart/form-data
  //         if (inputObj.items && inputObj.in !== this.ws.paramType.FORMDATA) {
  //           inputObj.items.type = inputObj.type;
  //         }
  //       } else {
  //         this.ws.inputParams.push(parameterObj);
  //       }
  //     });
  //     forEach(this.ws.inputParams, (parameterObj) => {
  //       // update the type of header param
  //       if (parameterObj.in === this.ws.paramType.HEADER.toLowerCase()) {
  //         parameterObj.type = this.ws.cachedHeaderParamsType[parameterObj.name]
  //           ? this.ws.cachedHeaderParamsType[parameterObj.name]
  //           : parameterObj.type;
  //         parameterObj.items = {};
  //         parameterObj.items.type = parameterObj.type;
  //       }
  //     });
  //   }
  //   this.setParameterizedUrl(this.ws.inputParams);
  //   this.ws.operationName = operationObject[WS_CONSTANTS.OPERATION_NAME_KEY];
  //   this.ws.contentType = operationObject.consumes
  //     ? operationObject.consumes[0]
  //     : "";
  //   // this.onContentTypeChange();
  //   this.webSocketService.toggleMessage(false);
  //
  //   // check auth params existence in the input params
  //   this.checkAuthParams(this.ws.inputParams);
  //
  //   //set content type for string/file type params for model purpose
  //   this.setContentType(this.ws.inputParams);
  //
  //   // cache the param test values for default service variables
  //   // this.cacheParamValues();
  //   // cache the header param types
  //   this.cacheHeaderParamsType();
  // }

  xmlToJson(xmlString: any, includeRoot?: any): any {
    try {
        let x2js = new X2JS({
            emptyNodeForm: "object", // Changed to a valid option: "object" or "text"
            attributePrefix: "",
            enableToStringFunc: false
        });

        // Attempt to parse the XML string
        let json:any = x2js.xml2js(xmlString);

        // Handle invalid XML case
        if (json?.html?.body?.parsererror) {
            throw new Error("Invalid XML format");
        }

        // If includeRoot is false, return the first property in the JSON object
        if (!includeRoot && json) {
            json = get(json, Object.keys(json)[0]);
        }

        return json;
    } catch (error:any) {
        return null;
    }
}



  //
  // setParameterizedUrl(val: any, type?: string) {
  //   let url = this.ws.webSocketUrl;
  //   // if parameterized url not set previously, return
  //   if (!url) {
  //     return;
  //   }
  //
  //   let index = includes(url, "?") ? url.indexOf("?") : url.length,
  //     plainURL = url.substring(0, index),
  //     i = 0,
  //     params = "";
  //
  //   // loop over each input param to form the parameterized url out of it
  //   forEach(val, (param) => {
  //     if (
  //       param[this.webSocketService.PARAMETER_TYPE_KEY].toUpperCase() === this.ws.paramType.QUERY
  //     ) {
  //       if (i === 0) {
  //         params += "?";
  //       } else {
  //         params += "&";
  //       }
  //       params += param.name + "=" + (this.ws.restInfoQuery[param.name] || "");
  //       i += 1;
  //     }
  //   });
  //   if (type === "websocket") {
  //     this.ws.webSocketUrl = plainURL + params;
  //   } else {
  //     this.ws.restURL = plainURL + params;
  //   }
  // }

  /*
   * checks the existence of auth params in the params list
   * if found, sets the ws.basicAuthRequired to true
   * @param {params} list of input parameters
   */
  checkAuthParams(params: any) {
    forEach(params, (param) => {
      if (
        param[this.webSocketService.PARAMETER_TYPE_KEY].toUpperCase() ===
        this.webSocketService.ws.paramType.AUTH.toUpperCase()
      ) {
        this.webSocketService.ws.basicAuthRequired = true;

        // remove the 'wm_auth_' part from the auth parameters
        param.displayName = param.name.replace("wm_auth_", "");
      }
    });
  }

  /*
   * set content type for string/file type params for model purpose
   * */
  // setContentType(params: any) {
  //   let paramType;
  //   forEach(params, (param) => {
  //     paramType = get(param, "items.type") || param.type;
  //     if (
  //       param[this.webSocketService.PARAMETER_TYPE_KEY] === this.ws.paramType.FORMDATA &&
  //       includes(this.primitiveMultipartTypes, paramType) &&
  //       !param[this.CONTENT_TYPE_KEY]
  //     ) {
  //       param[this.CONTENT_TYPE_KEY] = paramType;
  //     }
  //   });
  // }

  /*
   * caches the values provided for various params while testing the service
   * @param {none}
   */
  cacheParamValues() {
    // query params
    this.cachedParams = {};

    let url = this.webSocketService.ws.restURL,
      index = url.indexOf("?"),
      queryParams;

    // if query params found, extract them
    if (index !== -1) {
      queryParams = url.substring(index + 1, url.length);
      queryParams = queryParams.split("&");

      // loop over the query params and store each parameter's test value
      forEach(queryParams, (param) => {
        let i = param.indexOf("="),
          paramKey,
          paramVal;
        if (i !== -1) {
          paramKey = param.substr(0, i);
          paramVal = param.substr(i + 1, param.length);

          // if param with same name already found, make it an array and push next value into it
          if (this.cachedParams[paramKey]) {
            this.cachedParams[paramKey] = isArray(this.cachedParams[paramKey])
              ? this.cachedParams[paramKey]
              : [this.cachedParams[paramKey]];
            this.cachedParams[paramKey].push(paramVal);
          } else {
            this.cachedParams[paramKey] = paramVal;
          }
        }
      });
    }

    // loop over Header Params and store test values
    forEach(this.webSocketService.ws.headers, (val, key) => {
      this.cachedParams[key] = val;
    });

    // if post type request and sample post data provided, cache it in the body param
    if (!this.webSocketService.ws.isNonBodyMethodSelected && this.webSocketService.ws.requestBody) {
      this.cachedParams.RequestBody = this.webSocketService.ws.requestBody;
    }
  }

  // /**
  //  * caches the Header param types
  //  */
  // cacheHeaderParamsType() {
  //   this.ws.cachedHeaderParamsType = {};
  //   forEach(this.ws.inputParams, (paramObj) => {
  //     if (
  //       paramObj[this.webSocketService.PARAMETER_TYPE_KEY] ===
  //       this.ws.paramType.HEADER.toLowerCase()
  //     ) {
  //       this.ws.cachedHeaderParamsType[paramObj.name] =
  //         paramObj.format || paramObj.type;
  //     }
  //   });
  // }

  /**
   * handles URL change
   * if url starts with ws:// and studio is loaded over https, throws an error
   */
  onUrlChange(url: any, isInit?: any) {
    this.onPropertyChange();
    this.validateUrl(url);
    this.handleUrlChange(url, isInit, 'websocket');
  }

  onPropertyChange(){
    this.webSocketService.setServiceTestedStatus(false);
  }

   /**
    * Validating if the url specified is a valid web Socket URL
    * Badsed on URL validation the test button is enabled/disabled
    * @param url : url to be verified
    */
   validateUrl(url: any){
    if (!isValidWebSocketURL(url)) {
        this.testDisabled = true;
        this.webSocketService.toggleMessage(true, this.locale.MESSAGE_INVALID_WS_URL, 'warning');
    } else if (this.isInsecureContentRequest(url)) {
        this.testDisabled = true;
        this.webSocketService.toggleMessage(true, this.locale.MESSAGE_INSECURE_WS_URL, 'warning');
    } else {
        this.testDisabled = false;
        this.webSocketService.toggleMessage(false);
    }
  }

  isInsecureContentRequest(url: string) {
    let parser = document.createElement("a");
    return parser.href = url,
    "" !== parser.protocol && (!!stringStartsWith(location.href, "https://") && ("https:" !== parser.protocol && "wss:" !== parser.protocol))
  }

  // watch on the URL to check path params
  handleUrlChange(url:any, init:any, type: string) {
    let paramKeys:any;
    let isWebSocket = type === 'websocket';
    url = url || isWebSocket ? this.webSocketService.ws.webSocketUrl : this.webSocketService.ws.restURL;
    // if parameterized url not set previously, return
    if (!url) {
        return;
    }
    this.webSocketService.ws.restInfoQuery = this.assignQueryParamsFromURL(url);
    paramKeys = Object.keys(this.webSocketService.ws.restInfoQuery);
    this.webSocketService.ws.inputParams   = this.webSocketService.ws.inputParams || [];
    if (!init) {
        //remove the inputparams changed via URL
        remove(this.webSocketService.ws.inputParams,  (paramObj:any) => {
            return (paramObj.in === this.webSocketService.ws.paramType.PATH.toLowerCase() || paramObj.in === this.webSocketService.ws.paramType.QUERY.toLowerCase()) && !includes(paramKeys, paramObj.name);
        });
        // if the url is changed then disable save until the service is tested
        this.webSocketService.ws.isUrlChanged  = true;
        this.webSocketService.ws.isUrlTested   = false;
    }
    forEach(this.webSocketService.ws.restInfoQuery, (paramValue, param) => {
        if(!find(this.webSocketService.ws.inputParams, {name: param})) {
            this.webSocketService.ws.inputParams.push({
                'name'  : param,
                'in'    : this.webSocketService.ws.paramType.QUERY.toLowerCase(),
                'type'  : this.webSocketService.SERVICE_TYPES.STRING,
                'format': this.webSocketService.SERVICE_TYPES.STRING
            });
        }
    });
    if (!init) {
        //assign path params from the url
        this.clearParams(this.webSocketService.ws.paramType.PATH.toLowerCase());
    }
    url = url.split('?')[0];
    url.replace(/\{(.*?)\}/g,  (match: any, param: any) => {
        this.webSocketService.ws.newPathParam.name      = param;
        this.webSocketService.ws.newPathParam[this.TYPE_KEY] = this.webSocketService.SERVICE_TYPES.STRING;
        this.webSocketService.ws.serviceTested = false;
        this.addParam(this.webSocketService.ws.paramType.PATH);
        this.switchTab(this.webSocketService.ws.paramType.PATH, this.webSocketService.ws.activeServiceType === 'WebSocketService' ? true : false);
    });
    // to disable save when url is changed
    this.webSocketService.ws.serviceTested = false;
  }

  switchTab(type: string, isWebSocketService: boolean) {
    if(isWebSocketService) {
        this.webSocketService.ws.activeParamGroupIdx = findIndex(this.webSocketService.ws.webSocketServiceTabs, {id: type.toLowerCase()});
    } else {
        this.webSocketService.ws.activeTabIndex = findIndex(this.webSocketService.ws.webServiceTabs, {id: type.toLowerCase()});
    }
  }

  assignQueryParamsFromURL(url: string) {
    url = url || this.webSocketService.ws.restURL;

    let queryObject:any = {},
        allParams = url.split("?")[1],
        queryParams:any = allParams ? allParams.split("&") : {};

    if (isEmpty(queryParams)) {
        return {};
    }
    for (let i = 0; i < queryParams.length; i++) {
        let pair = queryParams[i].split("=");
        // If first entry with this name
        if (typeof queryObject[pair[0]] === "undefined") {
            queryObject[pair[0]] = decodeURIComponent(pair[1]?  pair[1] : '');
            // If second entry with this name
        } else if (typeof queryObject[pair[0]] === "string") {
            let arr = [queryObject[pair[0]], decodeURIComponent(pair[1])];
            queryObject[pair[0]] = arr;
            // If third or later entry with this name
        } else {
            queryObject[pair[0]].push(decodeURIComponent(pair[1]));
        }
    }

    return queryObject;
  }

  clearParams(type: string) {
    // initialize the parameter index from the end of the array
    let index = this.webSocketService.ws.inputParams.length;
    while (index--) {
        if (this.webSocketService.ws.inputParams[index][this.webSocketService.PARAMETER_TYPE_KEY] === type.toLowerCase()) {
            this.webSocketService.ws.inputParams.splice(index, 1);
        }
    }
  }

   // function to add a param to the input params array and disable useProxy if any param is configured as a server side property
   addParam(type: any) {
    let newParam;
    this.webSocketService.toggleMessage(); //remove the validation
    switch (type) {
        case this.webSocketService.ws.paramType.PATH:
            newParam = this.webSocketService.ws.newPathParam;
            break;
        case this.webSocketService.ws.paramType.FORMDATA:
            newParam = this.webSocketService.ws.newMultipartParam;
            if (this.isInvalidParam(newParam)) {
                return;
            }
            //Update param with all properties as per swagger specification
            this.modifyFormDataBodyParam(newParam);
            break;
        default:
            newParam = this.webSocketService.ws.newQueryParam;
            if (!newParam.name) {
                this.webSocketService.toggleMessage(true, this.locale.MESSAGE_WEBSERVICES_EMPTY_PARAM, 'error');
                return;
            }
            if (this.webSocketService.ws.restInfoQuery) {
                if (this.webSocketService.ws.restInfoQuery.hasOwnProperty(newParam.name)) {
                  this.webSocketService.toggleMessage(true, replace(this.locale.MESSAGE_WEBSERVICES_DUPLICATE_PARAM, [this.webSocketService.ws.newQueryParam.name]), 'error');
                    return;
                } else {
                  this.webSocketService.ws.restInfoQuery[newParam.name] = newParam.value || '';
                }
            } else {
                this.webSocketService.ws.sampleParamValues[newParam.name] = newParam.value;
            }
            // showing error message if the new query param type is empty
            if (!newParam.format) {
                this.webSocketService.ws.serviceTested = false;
                delete this.webSocketService.ws.restInfoQuery[newParam.name];
                this.webSocketService.toggleMessage(true, replace(this.locale.MESSAGE_EMPTY_PARAM_TYPE, [this.webSocketService.ws.newQueryParam.name]), 'error');
                return;
            }
            newParam.type = newParam.format;
            this.webSocketService.setTypeBasedOnFormat(newParam);
    }
    if (this.isInvalidParam(newParam)) {
        return;
    }
    this.webSocketService.ws.inputParams.push(getClonedObject(newParam));
    this.webSocketService.setParameterizedUrl(this.webSocketService.ws.inputParams, 'websocket')
    // disables the useProxy flag if there is atleast one param (Header or Query) which is configured as a Server Side property or App Environment property
    this.disableUseProxyBasedOnParamType(false);
    newParam = {};
    //enable save button when a param is added
    this.webSocketService.ws.serviceTested = true;
    //Reset ng-model of param types.
    this.webSocketService.ws.newQueryParam.name    = '';
    this.webSocketService.ws.newQueryParam.type    = this.webSocketService.SERVICE_TYPES.STRING;
    this.webSocketService.ws.newQueryParam.format  = this.webSocketService.SERVICE_TYPES.STRING;
    this.webSocketService.ws.newQueryParam.value   = '';
    // this.webSocketService.ws.newHeaderParam.name   = '';
    // this.webSocketService.ws.newHeaderParam.type   = this.webSocketService.SERVICE_TYPES.STRING;
    // this.webSocketService.ws.newHeaderParam.format = this.webSocketService.SERVICE_TYPES.STRING;
    // this.webSocketService.ws.newHeaderParam.value  = '';
    this.webSocketService.ws.newMultipartParam     = this.getNewMultipartParam();
  }

  getNewMultipartParam() {
    let newParam:any = {
        'type' : 'file',
        'value': '',
        'list' : true
    };
    newParam[this.webSocketService.PARAMETER_TYPE_KEY] = this.webSocketService.ws.paramType.FORMDATA;
    newParam[this.CONTENT_TYPE_KEY]   = 'file';
    return newParam;
};

  // disables the useProxy flag if there is atleast one param (Header or Query) which is configured as a Server Side property or App Environment property
  disableUseProxyBasedOnParamType(hasNewParam: any, paramType?: any) {
    let containsServerSideProperty = false,
        containsAppEnvProperty = false;
    some(this.webSocketService.ws.inputParams, (paramObj) => {
        containsServerSideProperty = this.isServerSideProperty(paramObj.type);
        containsAppEnvProperty = this.isAppEnvironmentProperty(paramObj.type);
        // check if params contain server side property or app environment property
        if (containsServerSideProperty || containsAppEnvProperty) {
            this.webSocketService.ws.disableUseProxy = true;
            return true;
        } else if (this.webSocketService.ws.disableUseProxy) {
            this.webSocketService.ws.disableUseProxy = false;
        }
        return false;
    });
    // check the param type of the new (header or query) param which is added while testing the service
    if (hasNewParam){
        containsServerSideProperty = this.isServerSideProperty(paramType);
        containsAppEnvProperty = this.isAppEnvironmentProperty(paramType);
        // check if param contains server side property or app environment property
        if (containsServerSideProperty || containsAppEnvProperty) {
            this.webSocketService.ws.disableUseProxy = true;
        } else if (this.webSocketService.ws.disableUseProxy) {
            this.webSocketService.ws.disableUseProxy = false;
        }
    }
  }

  // function to check if the param type is a Server Side property
   isServerSideProperty(type: any) {
       return find(DB_CONSTANTS.SERVER_SIDE_PROPERTIES, {value: type});
   }

   // to check if the param type is an App Environment property
   isAppEnvironmentProperty(type: string | undefined) {
      return  startsWith(type, this.VARIABLE_APP_ENV);
   }

  /*
   * checks if the provided param is complete and if param exists in current list
   * @param newParam param to be checked for existence
   */
  isInvalidParam(newParam: { [x: string]: any; name: any; }) {
    // newParam[this.SCHEMA_KEY[this.ITEMS_KEY[this.TYPE_KEY]]]
    if (!newParam.name || !(newParam[this.TYPE_KEY] ) || this.webSocketService.ws.inputParams.find((param: { name: any; }) => param.name === newParam.name)) {
        return true;
    }else{
      return false;
    }
  }



  /*
   * Update param with all properties as per swagger specification
   * */
  modifyFormDataBodyParam(newParam: { type: string; list: any; items: { type: any; }; value: any; name: string | number; }) {
    let $newFileInputMarkup = '<input type="file" onchange="WM.element(this).scope().ws.onFileChange(this, WM.element(this).scope().ws.newMultipartParam)" class="form-control app-fileupload new-file-input" multiple>',
        newParamType = newParam.type;
    if (this.webSocketService.ws.editMode) {
        //Setting the type as per swagger specification
        if (newParam.list) {
            let dataType = newParam.type;
            newParam.type = 'array';
            newParam.items = {'type' : dataType};
            delete newParam.value;
            delete newParam.list;
        }
        this.webSocketService.ws.restInfoMultipart[newParam.name] = newParam.value;
    } else {
        this.webSocketService.ws.multipartParams.push(newParam);
    }
    //Move file model from dummy tr to model
    if (newParamType === 'file') {
        setTimeout( () =>{
            let $newFileInput = $('.new-file-input');
            $newFileInput.removeClass('new-file-input');
            $newFileInput.attr('onchange', 'WM.element(this).scope().ws.onFileChange(this, WM.element(this).scope().param)');
            let i = this.webSocketService.ws.multipartParams.length;

            let $target = $('.multipart-table tr[ng-Repeat]:last .file-input-td');
            $target.empty().append($newFileInput);

            $('.new-file-input-td').empty().append($newFileInputMarkup);
        });
    }
  }

  // function to remove a param from the inputParams array and enables useProxy if no param is configured as server side property.
  removeParam(param :any) {
    let i, n;
    for (i = 0, n = this.webSocketService.ws.inputParams.length; i < n; i += 1) {
        if (this.webSocketService.ws.inputParams[i].name === param.name && this.webSocketService.ws.inputParams[i][this.webSocketService.PARAMETER_TYPE_KEY] === param[this.webSocketService.PARAMETER_TYPE_KEY]) {
            // remove param from the list
            this.webSocketService.ws.inputParams.splice(i, 1);
            switch (param[this.webSocketService.PARAMETER_TYPE_KEY]) {
            case this.webSocketService.ws.paramType.QUERY.toLowerCase():
                if (this.webSocketService.ws.restInfoQuery) {
                    delete this.webSocketService.ws.restInfoQuery[param.name];
                    this.webSocketService.setParameterizedUrl(this.webSocketService.ws.restInfoQuery, 'websocket')
                }
                break;
            case this.webSocketService.ws.paramType.HEADER.toLowerCase():
                if (this.webSocketService.ws.restInfoHeaders) {
                    delete this.webSocketService.ws.restInfoHeaders[param.name];
                    delete this.webSocketService.ws.cachedHeaderParamsType[param.name];
                }
                break;
            case this.webSocketService.ws.paramType.FORMDATA:
                if (this.webSocketService.ws.editMode) {
                    delete this.webSocketService.ws.restInfoMultipart[param.name];
                } else {
                    remove(this.webSocketService.ws.multipartParams, {"name": param.name});
                }
                break;
            }

            /* remove param from the cached prams */
            if (this.cachedParams) {
                delete this.cachedParams[param.name];
            }
            // disables the useProxy flag if there is atleast one param (Header or Query) which is configured as a Server Side property or App Environment property
            this.disableUseProxyBasedOnParamType(false);
            //enable save button when a param is removed
            this.webSocketService.ws.serviceTested = true;
            return;
        }
    }
  }
  /**
   * send message through the connected socket
   */
  sendMessage() {
    let message = this.webSocketService.getRequestBody();
    this.getSocket().send(message);
  }

  /**
         * Imports the WebSocket service into the project
         */
  importService() {
    return new Promise((resolve, reject) => {
    this.webSocketService.toggleMessage(true, this.locale.LABEL_IMPORT_WEB_SOCKET_SERVICE, 'loading');
    this.webSocketService.buildService( (response: any) => {
        this.handleSuccessServiceImport({
            'serviceId'      : response,
            'serviceType'    : VARIABLE_CONSTANTS.SERVICE_TYPE_WEBSOCKET,
            'successMsg'     : 'MESSAGE_SUCCESS_WEB_SERVICE_WEBSOCKET_BUILD'
        });
        resolve(response.result)
    }, (error: any) => {
        this.webSocketService.handleError(error, {'fallbackMsg': 'error while configuring socket service, please check server logs for more info.'});
        reject()
    });
  });
  }



   // function to check if the service being created already exists
   serviceExists(response: any) {
    let serviceName,
        errMsg;
    if (includes(response, this.ALREADY_EXISTS)) {
        serviceName = response.substring(response.lastIndexOf('$') + 1, response.length);
        errMsg      = this.locale.MESSAGE_ERROR_WEB_SERVICE_EXISTS_ONE + ' ' + serviceName + ' ' + this.locale.MESSAGE_ERROR_WEB_SERVICE_EXISTS_TWO;
        this.webSocketService.toggleMessage(true, errMsg, 'error');

        return true;
    }
    return false;
}

  // function to handle actions to be taken after successful import of a web service
  handleSuccessServiceImport(options:any) {
    if (this.serviceExists(options.serviceId)) { //if service exists already, simply return
        return;
    }
    this.notificationService.show('success', this.locale.MESSAGE_SUCCESS_TITLE, this.locale[options.successMsg]);
    //If the service is imported from WidgetConfigDialog, after importing the service WidgetConfigDialog must be opened to continue with further steps instead of opening the web service
    // runtimeEventManager.emit('open-webservice',  options.serviceId, options.serviceType);
    // if (!get(this.$parent.dialogParams, 'widgetConfigDetails.widgetDetailsObj')) {
    //     //emit event to open web service
    //     this.$emit('open-webservice',  options.serviceId, options.serviceType);
    // }
    // if (get(this.$parent.dialogParams, 'widgetConfigDetails.action') === 'REIMPORT') {
    //     Utils.triggerFn(get(this.$parent.dialogParams, 'widgetConfigDetails.onSuccess'));
    // }
    // this.apiService._refreshApiService.next({reloadFlag: true});
    this.serviceFactory.removeService(options.serviceId);
    // this.$emit('update-services-tree', options.serviceType, options.serviceId, options.sampleResponse, null, options.cachedParams, false);
    // this.$emit('update-resources-tree');

  }


  processRequestBodyForImport(requestBody:any, type:any) {
    // get the customized relative URL (if path params embedded)
    let parameterizedUrl = this.webSocketService.ws.webSocketUrl ,
        urlProtocol,
        relativeUrl,
        slashIndex,
        index,
        endpoints,
        i,
        nEndpoints,
        j,
        nOperations,
        pathKey,
        pathObj,
        connectionParams,
        operationObject;

    parameterizedUrl = parameterizedUrl.split('://');
    urlProtocol = parameterizedUrl[0];
    parameterizedUrl = parameterizedUrl[1];
    requestBody.swagger.schemes[0] = urlProtocol;

    slashIndex    = parameterizedUrl.indexOf('/');
    slashIndex    = slashIndex === -1 ? parameterizedUrl.indexOf('?') : slashIndex;
    slashIndex    = slashIndex === -1 ? parameterizedUrl.length : slashIndex;
    requestBody.swagger.host = parameterizedUrl.substr(0, slashIndex);
    relativeUrl   = parameterizedUrl.substr(slashIndex, parameterizedUrl.length);
    index         = relativeUrl.indexOf('?') !== -1 ? relativeUrl.indexOf('?') : relativeUrl.length;
    relativeUrl   = relativeUrl.substring(0, index) || '/';
    // requestBody.swagger.basePath = relativeUrl;
    pathKey       = keys(requestBody.swagger.paths)[0];
    pathObj       = requestBody.swagger.paths[pathKey];
    operationObject = pathObj[keys(pathObj)[0]];
    operationObject.parameters    = operationObject.parameters || [];
    operationObject.parameters    = this.webSocketService.transformQueryParam(operationObject.parameters);

    //Remove content type for string/file type params
    // removeContentType(operationObject.parameters);

    requestBody.proxySettings  = {
        'web': this.webSocketService.ws.useProxyForWeb ? this.webSocketService.RUNTIME_CALL_MODE.PROXY : this.webSocketService.RUNTIME_CALL_MODE.DIRECT, // for web api, use proxy settings with which the call was made.
        'mobile': this.webSocketService.ws.useProxy ? this.webSocketService.RUNTIME_CALL_MODE.PROXY : this.webSocketService.RUNTIME_CALL_MODE.DIRECT, // for mobile api, use whatever is selected in the designer.
        'withCredentials': this.webSocketService.ws.withCredentials ? true : false // If direct call, then withCredentials flag should be sent or not.
    };
        requestBody.serviceId = this.webSocketService.ws.serviceName;
        endpoints = requestBody.swagger.paths;
        // update only the required endpoint and operation based on the filteredEndpoint and filteredOperation ids
        for (i = 0, nEndpoints = endpoints.length; i < nEndpoints; i++) {
            if (endpoints[i].id === requestBody.filteredEndPointId) {
                endpoints[i].relativePath = relativeUrl;
                for (j = 0, nOperations = endpoints[i].operations.length; j < nOperations; j++) {
                    if (endpoints[i].operations[j].id === requestBody.filteredOperationId) {
                        endpoints[i].operations[j].methodType = this.webSocketService.ws.serviceMethod;
                        endpoints[i].operations[j].consumes   = this.webSocketService.ws.contentTypeKey ? [this.webSocketService.ws.contentTypeMap[this.webSocketService.ws.contentTypeKey]] : [];
                        break;
                    }
                }
                break;
            }
        }


    connectionParams = {
        'data'      : requestBody,
        'urlParams' : {
            'projectID': this.projectService.getProjectId()
        }
    };
    return connectionParams;
  }




  override ngOnDestroy() {
    this.webSocketService.viewMode = ''
    super.ngOnDestroy();
  }


}
